import cartDuck from 'components/cart/duck'
import cartItemsDuck from 'components/cart/cart-items/duck'

// Opening the bag only reads the current cart; it never repeats an addition.
export default () => (dispatch, getState) => {
  const { cartData } = getState()
  dispatch(cartItemsDuck.creators.update({ ...cartData, cartOpen: true }))
  return dispatch(
    cartDuck.creators.fetch({
      type: 'GET',
      keepPayload: true,
      body: { is_store_credits_applied: cartData.isStoreCreditUsed },
    }),
  )
}
